<template>
  <div data-testid='geolocation'>
    <div
      @click="showHelp = !showHelp"
      class="geolocation-error"
      v-if="geolocationError"
    >
      Geolocation is disabled in this browser
      <span class="material-symbols-outlined help pointer">help_outline</span>
    </div>
    <section v-if="showHelp">
      <div @click="showHelp = !showHelp" class="why">
        <h5>What does this mean?<span class="hide pointer">X</span></h5>
        <p>
          RUX uses your browsers Geolocation service to save your location
          whenever you scan your RUX! Thats all we use it for, we promise.
        </p>
        <p>
          Your Geolocation services are currently disabled, please enable it to
          get the most of your RUX!
        </p>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'GeoLocation',
  data: function () {
    return {
      geolocationError: false,
      geolocationPos: null,
      showHelp: false,
    }
  },
  mounted() {
    // This checks whether Geolocation is enabled here. Geo is used for saving the last know location of the RUX
    // This is all part of the GelocationAPI.
    if (!('geolocation' in navigator)) {
      this.geolocationError = true
      this.$store.dispatch('rux/setGeolocation', {
        isSet: true,
      })
    } else {
      navigator.geolocation.getCurrentPosition(
        (pos) => {
          this.geolocationPos = {
            latitude: pos.coords.latitude,
            longitude: pos.coords.longitude,
          }

          // If Geolocation is working update the store
          if (
            this.geolocationPos &&
            this.geolocationPos.latitude &&
            this.geolocationPos.longitude
          ) {
            this.$store.dispatch('rux/setGeolocation', {
              lat: this.geolocationPos.latitude,
              long: this.geolocationPos.longitude,
              isSet: true,
            })
          } else {
            this.$store.dispatch('rux/setGeolocation', {
              isSet: true,
            })
          }
        },
        () => {
          this.$store.dispatch('rux/setGeolocation', {
            isSet: true,
          })
          this.geolocationError = true
        }
      )
    }
  },
}
</script>

<style lang='scss' scoped>
.geolocation-error {
  color: white;
  padding: 8px;
  padding-top: 2px;
  background-color: $ruxGreen;
}
.help {
  position: relative;
  top: 6px;
}
.why {
  background-color: $ruxBeige;
  border-radius: 8px;
  padding: 24px;
  margin-top: 10px;
}
.hide {
  float: right;
  margin-right: 5px;
  font-size: 1rem;
}
</style>